import { render, staticRenderFns } from "./forumlist.vue?vue&type=template&id=0a1109a2&scoped=true"
import script from "./forumlist.vue?vue&type=script&lang=js"
export * from "./forumlist.vue?vue&type=script&lang=js"
import style0 from "./forumlist.vue?vue&type=style&index=0&id=0a1109a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_163004cd90115b55449e6d2350f1be1c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1109a2",
  null
  
)

export default component.exports